<svelte:options />

<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} name
     * @property {boolean} [required]
     * @property {any} value
     * @property {any} [min]
     * @property {any} [defaultValue]
     * @property {any} associatedID
     * @property {number} [tabindex]
     */
    let {
        name,
        required = false,
        value = $bindable(),
        min = new Date().toISOString().slice(0, 16),
        defaultValue = null,
        associatedID = null,
        tabindex = 0
    } = $props();

    const dispatch = createEventDispatcher();

    if (value && typeof value === 'object' && value?.toDate()) {
        value = convertEpochToDatetimeLocal(value.toDate().getTime());
    } else if (value) {
        value = convertEpochToDatetimeLocal(value);
    }
    
    function handleFocus(e) {
        // If no value is set and we have a defaultValue, set it when user focuses
        if (!value && defaultValue) {
            value = defaultValue;
            e.target.value = defaultValue;
        }
    }
    
    function handleChange(e) {
        value = e.target.value;
        dispatch('change', {
            originalEvent: e,
            name,
            value,
            required,
            associatedID,
        });
    }

    function convertEpochToDatetimeLocal(epoch) {
        const date = new Date(epoch);

        // Get local time components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Format as "YYYY-MM-DDTHH:MM" (without seconds)
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    export {
        name,
        required,
        value,
        min,
        defaultValue,
        associatedID,
        tabindex,
    };
</script>

<div class="date-input">
    <input
        class="input"
        {tabindex}
        onchange={handleChange}
        onblur={handleChange}
        onfocus={handleFocus}
        onkeyup={(e) => {
            dispatch('keyup', e);
        }}
        type="datetime-local"
        {name}
        {required}
        {value}
        {min}
        aria-label="DateTime Input"
        id={name}
    />
</div>

<style>
    .date-input {
        display: flex;
        flex-direction: row;
        flex-grow: 10;
        width: 100%;
        max-width: 24rem;
    }

    .date-input:not(:last-of-type) {
        margin-right: 1rem;
    }

    .input {
        padding: 0.75rem;
        background-color: rgba(0, 0, 0, 0.6);
        color: #eee;
        border-radius: 0.35rem;
        border: solid 1px rgba(0, 0, 0, 0.1);
        width: 100%;
        color-scheme: dark;
    }

    .input:focus {
        background-color: rgba(0, 0, 0, 0.5);
        outline: 1px solid rgb(74, 198, 255);
        color: #eee;
    }

    .input:invalid {
        outline: 1px solid rgb(255, 192, 74);
    }
</style>
